<template>
  <v-window v-model="step">
    <v-window-item :value="1">
      <testate @apriDettaglio="apriDettaglio"/>
    </v-window-item>
    <v-window-item :value="2">
      <dettaglio :chiaveMovimento="chiaveMovimento" @back="tornaIndietro"/>
    </v-window-item>
  </v-window>
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import Testate from './components/testate'
  import Dettaglio from './components/dettaglio'

  export default {
    components: {
      Testate,
      Dettaglio
    },
    mixins: [verificaLicenza],
    data: () => ({
      step: 1,
      chiaveMovimento: null
    }),
    async mounted() {
      // await this.gestioneToken()
      await this.verificaModuliLocali()
      this.$store.commit('movimenti/SET_PAGE', 'testate')
    },
    computed: {
      gotoBase() {
        return this.$store.getters['movimenti/gotoBase']
      }
    },
    watch: {
      gotoBase(value) {
        if (value) {
          this.step = 1
          this.$store.commit('movimenti/CLEAR_GOTO_BASE')
        }
      }
    },
    methods: {
      apriDettaglio(chiave) {
        // console.log('chiave', chiave)
        this.chiaveMovimento = chiave
        this.$store.commit('movimenti/SET_PAGE', 'dettaglio')
        this.step = 2
      },
      tornaIndietro() {
        this.step = 1
        this.$store.commit('movimenti/SET_PAGE', 'testate')
        this.$store.commit('movimenti/SET_CHIAVE', null)
        this.$store.commit('movimenti/CLEAR_MOVIMENTO')
        this.chiaveMovimento = null
      }
    }
  }
</script>
